import { useMediaQuery, useTheme } from '@mui/material';
import { RightMenuNavigation } from 'app/enums';
import React, { createContext, FC, useCallback, useEffect, useState } from 'react';

interface RightSidebarProviderProps {
  activeTab: RightMenuNavigation;
  setActiveTab: (value: RightMenuNavigation) => void;
}

export const RightSidebarContext = createContext<RightSidebarProviderProps>({
  activeTab: RightMenuNavigation.GlobalChat,
  setActiveTab: () => {},
});

export const RightSidebarProvider: FC = ({ children }) => {
  const theme = useTheme();
  const isFullScreen = useMediaQuery(theme.breakpoints.up('lg'), { noSsr: true });
  const [activeTab, setActiveTab] = useState(RightMenuNavigation.GlobalChat);

  const changeTabHandler = useCallback(
    (value: RightMenuNavigation) => {
      if (value === RightMenuNavigation.Home && isFullScreen) {
        return;
      }

      setActiveTab(value);
    },
    [isFullScreen]
  );

  useEffect(() => {
    const value = !isFullScreen ? RightMenuNavigation.Home : RightMenuNavigation.GlobalChat;

    setActiveTab(value);
  }, [setActiveTab, isFullScreen]);

  return (
    <RightSidebarContext.Provider value={{ activeTab, setActiveTab: changeTabHandler }}>
      {children}
    </RightSidebarContext.Provider>
  );
};
